import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FW_VERSION, OTA, FOTA_STATUS } from "../api/api";

// Poll FOTA status
export const pollFotaStatus = createAsyncThunk(
  "pollFotaStatus",
  async ({ gatewayId, header }, { rejectWithValue }) => {
    try {
      const response = await FOTA_STATUS(gatewayId, header);
      return response?.data;
    } catch (error) {
      if (
        error.response?.data?.message === "Invalid token" ||
        error.response?.data?.message === "Access denied"
      ) {
        window.localStorage.clear();
        window.location.href = "./";
      }
      return rejectWithValue(error.response?.data);
    }
  }
);

export const Fw_version = createAsyncThunk(
  "Fw_version",
  async ({ header }, { rejectWithValue }) => {
    try {
      const response = await FW_VERSION( header);
      return response?.data;
    } catch (error) {
      if (
        error.response.data.message === "Invalid token" ||
        error.response.data.message === "Access denied"
      ) {
        window.localStorage.clear();
        window.location.href = "./";
      }
      return rejectWithValue(error.response.data);
    }
  }
);
export const Ota = createAsyncThunk(
  "Ota",
  async ({data, header }, { rejectWithValue }) => {
    try {
      
      const response = await OTA(data, header);
      return response?.data;
    } catch (error) {
      if (
        error.response.data.message === "Invalid token" ||
        error.response.data.message === "Access denied"
      ) { 
        window.localStorage.clear();
        window.location.href = "./";
      }
      return rejectWithValue(error.response.data);
    }
  }
);


const initialState = {
    status1: "",
    loading1: false,
  
    fw_version_response: "",
    fw_version_error: null,
    
    ota_response: "",
    ota_error: null,

  fota_status: null,
  fota_status_loading: false,
  fota_status_error: null,
  };

  export const FotaSlice = createSlice({
    name: "FotaSlice",
    initialState,
    reducers: {
      // Logout reducer
      clearfw_versionError: (state) => {
        state.fw_version_error = null;
      },
      clearfw_versionResponse: (state) => {
        state.fw_version_response = "";
      },
      clearotaError: (state) => {
        state.ota_error = null;
      },
      clearotaResponse: (state) => {
        state.ota_response = "";
      },
    },
    extraReducers: (builder) => {
      // Poll FOTA status
      builder.addCase(pollFotaStatus.pending, (state) => {
        state.fota_status_loading = true;
        state.fota_status_error = null;
      });
      builder.addCase(pollFotaStatus.fulfilled, (state, { payload }) => {
        state.fota_status_loading = false;
        state.fota_status = payload;
        state.fota_status_error = null;
      });
      builder.addCase(pollFotaStatus.rejected, (state, { payload }) => {
        state.fota_status_loading = false;
        state.fota_status_error = payload;
      });
      // Add reducers for additional action types here, and handle loading1 state as needed
      builder.addCase(Fw_version.pending, (report, { payload }) => {
        // Add user to the state array
        report.status1 = "Loading...";
        report.loading1 = true;
      });
  
      builder.addCase(Fw_version.fulfilled, (report, { payload }) => {
        // Add user to the state array
        report.status1 = "Success";
        report.loading1 = false;
        report.fw_version_response = payload;
        report.fw_version_error = null;
      });
      builder.addCase(Fw_version.rejected, (report, { payload }) => {
        // Add user to the state array
        report.status1 = "Failed";
        report.loading1 = false;
        report.fw_version_error = payload;
      });

      // Add reducers for additional action types here, and handle loading1 state as needed
      builder.addCase(Ota.pending, (report, { payload }) => {
        // Add user to the state array
        report.status1 = "Loading...";
        report.loading1 = true;
      });
  
      builder.addCase(Ota.fulfilled, (report, { payload }) => {
        // Add user to the state array
        report.status1 = "Success";
        report.loading1 = false;
        report.ota_response = payload;
        report.ota_error = null;
      });
      builder.addCase(Ota.rejected, (report, { payload }) => {
        // Add user to the state array
        report.status1 = "Failed";
        report.loading1 = false;
        report.ota_error = payload;
      });
    },
  });
  export const {  clearfw_versionError, clearfw_versionResponse,clearotaError,clearotaResponse,} = FotaSlice.actions;
  
  export default FotaSlice.reducer;